import React from 'react';

import { matchDisplayName } from '../utils';

import styles from './styles.module.scss';

export const FormRow = (props) => (
  <div className={styles.formRow}>
    {React.Children.map(props.children, (childRef) => {
      if (matchDisplayName(childRef, 'FormItem')) {
        return React.cloneElement(childRef, {
          className: styles.inputGroupFormItem
        });
      } else {
        return childRef;
      }
    })}
  </div>
);
